export default "__VITE_ASSET__jwqt6nLg__"